module.exports = __webpack_public_path__ + "img/issuing-sample-process-3.e443f4f9.png";